module.exports = __webpack_public_path__ + "img/mark-folder-back-conditions.7c211aa.svg";